export const GET_WORKLIST_DEFINITIONS_REQUEST = 'GET_WORKLIST_DEFINITIONS_REQUEST';
export const GET_WORKLIST_DEFINITIONS_SUCCESS = 'GET_WORKLIST_DEFINITIONS_SUCCESS';
export const GET_WORKLIST_DEFINITIONS_FAILURE = 'GET_WORKLIST_DEFINITIONS_FAILURE';

export const GET_WORKLIST_DATA_REQUEST = 'GET_WORKLIST_DATA_REQUEST';
export const GET_WORKLIST_DATA_SUCCESS = 'GET_WORKLIST_DATA_SUCCESS';
export const GET_WORKLIST_DATA_FAILURE = 'GET_WORKLIST_DATA_FAILURE';

export const GET_WORKLIST_DATA_NEXT_REQUEST = 'GET_WORKLIST_DATA_NEXT_REQUEST';
export const GET_WORKLIST_DATA_NEXT_SUCCESS = 'GET_WORKLIST_DATA_NEXT_SUCCESS';
export const GET_WORKLIST_DATA_NEXT_FAILURE = 'GET_WORKLIST_DATA_NEXT_FAILURE';

export const GET_WORKLIST_VIEWS_REQUEST = 'GET_WORKLIST_VIEWS_REQUEST';
export const GET_WORKLIST_VIEWS_SUCCESS = 'GET_WORKLIST_VIEWS_SUCCESS';
export const GET_WORKLIST_VIEWS_FAILURE = 'GET_WORKLIST_VIEWS_FAILURE';

export const CREATE_WORKLIST_VIEW_REQUEST = 'CREATE_WORKLIST_VIEW_REQUEST';
export const CREATE_WORKLIST_VIEW_SUCCESS = 'CREATE_WORKLIST_VIEW_SUCCESS';
export const CREATE_WORKLIST_VIEW_FAILURE = 'CREATE_WORKLIST_VIEW_FAILURE';

export const UPDATE_WORKLIST_VIEWS_REQUEST = 'UPDATE_WORKLIST_VIEWS_REQUEST';
export const UPDATE_WORKLIST_VIEWS_SUCCESS = 'UPDATE_WORKLIST_VIEWS_SUCCESS';
export const UPDATE_WORKLIST_VIEWS_FAILURE = 'UPDATE_WORKLIST_VIEWS_FAILURE';

export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const UPDATE_WORKLIST_SORT = 'UPDATE_WORKLIST_SORT';
export const UPDATE_VIEW = 'UPDATE_VIEW';
export const UPDATE_DEFAULT_EXPAND = 'UPDATE_DEFAULT_EXPAND';

export const CLEAR_WORKLIST_DATA = 'CLEAR_WORKLIST_DATA';

export const SET_OPEN_ACTIONS = 'SET_OPEN_ACTIONS';

export const CLEAR_VIEWS = 'CLEAR_VIEWS';

export const SET_CURRENT_WORKLIST_ID = 'SET_CURRENT_WORKLIST_ID';

export const SET_CHILD_DETAIL_PARAMS = 'SET_CHILD_DETAIL_PARAMS';

export const SET_MAPPED_COLUMNS = 'SET_MAPPED_COLUMNS';
export const SET_CHILD_SELECTION = 'SET_CHILD_SELECTION';
export const SET_OPEN_FILTER_ID = 'SET_OPEN_FILTER_ID';

export const GET_WORKLIST_METADATA_REQUEST = 'GET_WORKLIST_METADATA_REQUEST';
export const GET_WORKLIST_METADATA_SUCCESS = 'GET_WORKLIST_METADATA_SUCCESS';
export const GET_WORKLIST_METADATA_FAILURE = 'GET_WORKLIST_METADATA_FAILURE';

export const REFRESH_WORKGRID = 'REFRESH_WORKGRID';

export const GET_WORKLIST_DATA_BY_ID_REQUEST = 'GET_WORKLIST_DATA_BY_ID_REQUEST';
export const GET_WORKLIST_DATA_BY_ID_SUCCESS = 'GET_WORKLIST_DATA_BY_ID_SUCCESS';
export const GET_WORKLIST_DATA_BY_ID_FAILURE = 'GET_WORKLIST_DATA_BY_ID_FAILURE';

export const TRIGGER_ROW_HIGHLIGHT = 'TRIGGER_ROW_HIGHLIGHT';

export const RESET_ERROR = 'RESET_ERROR';

export const RESET_ALL_ADDITIONAL_FILTER_PARAMS = 'RESET_ALL_ADDITIONAL_FILTER_PARAMS';
